import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-np-singh',
  templateUrl: './np-singh.component.html',
  styleUrls: ['./np-singh.component.scss']
})
export class NpSinghComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getNPSingh();
  }

}
